import CryptoJS from 'crypto-js'
import Cookies from 'js-cookie'
import axios from 'axios'

const CRYPTO_SECRET_KEY = process.env.VUE_APP_CRYPTO_SECRET_KEY

// ===
// Private helpers
// ===
function encrypt (text) {
  return CryptoJS.AES.encrypt(text, CRYPTO_SECRET_KEY).toString()
}

function decrypt (cipherText) {
  const bytes = CryptoJS.AES.decrypt(cipherText, CRYPTO_SECRET_KEY)
  return bytes.toString(CryptoJS.enc.Utf8)
}

function saveState (key, value, token = false) {
  if (token) window.localStorage.setItem(key, value)
  else window.localStorage.setItem(key, JSON.stringify(value))
}

function saveTokenState (key, value) {
  if (value) {
    window.localStorage.setItem(key, value)
    Cookies.set(key, value, { path: '/' })
    return
  }

  window.localStorage.removeItem(key)
  Cookies.remove(key, { path: '/' })
}

function setDefaultAuthHeaders (state) {
  axios.defaults.headers.common.Authorization = state.token
    ? `Bearer ${decrypt(state.token)}`
    : ''
}

const mutations = {
  SET_PROFILE (state, newValue) {
    state.profile = newValue
    saveState('profile', newValue)
  },
  SET_TOKEN (state, newValue) {
    const encryptedToken = newValue ? encrypt(newValue) : null
    state.token = encryptedToken
    saveTokenState('token', encryptedToken)
    setDefaultAuthHeaders(state)
  },
  SET_REFRESH_TOKEN (state, newValue) {
    const encryptedToken = newValue ? encrypt(newValue) : null
    state.refresh_token = encryptedToken
    saveTokenState('refresh_token', encryptedToken)
    setDefaultAuthHeaders(state)
  },
  SET_ID_TOKEN (state, newValue) {
    const encryptedToken = newValue ? encrypt(newValue) : null
    state.id_token = encryptedToken
    saveTokenState('id_token', encryptedToken)
  },
  SET_AXIOS_TOKEN (state, newValue) {
    setDefaultAuthHeaders(state)
  }
}

export default mutations
